import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import {
  Home,
  NewHome,
  Error,
  Company,
  ManageCompany,
  Plan,
  SuccessPlan,
  ManagePlan,
  ManageEligibility,
  Mapper,
  MapperHome,
  ManageEmployee,
  ManageCensus,
  ManagePayroll,
  ManageTempMap,
  PayrollManage,
  PayrollFileStatus,
  PayrollReports,
  ManageMaintenance,
  ManageReport,
  // Reports,
  UnderConstruction,
  EnrollmentReport,
  EnrollmentDetailReport,
  CreatePayrollListing,
  Doco_Center,
  Doco,
  SponsorLayout,
  OutputFiles,
  ManageCommunication,
  ManageTrade,
  ManageForfeitureSummary,
  WithdrawalRequest,
  WithdrawalSummary,
  Approval,
  Draft,
  Distribution,
  ManageTransaction,
  ManageMaster,
  ManageFee,
  MainLayout,
  PayrollCensusDetailsContainer,
  ManageRkaas,
  CreateFee,
  FeeRun,
} from "../layouts";
import ApiAuthorizationRoutes from "../components/api-authorization/ApiAuthorizationRoutes";
import { ApplicationPaths } from "../components/api-authorization/ApiAuthorizationConstants";

import {
  ROUTES,
  ApplicationRoute,
  MANAGE_ENROLLMENT_ROUTES,
  MANAGE_PAYROLL_ROUTES,
} from "../utils";
import SponsorEmployeeSummaryContainer from "../containers/SponsorEmployeeSummaryContainer/SponsorEmployeeSummaryContainer";
import ManageDistribution from "../layouts/Distribution/ManageDistribution/ManageDistribution";
import { MANAGE_DISTRIBUTION_ROUTES } from "../utils/constants/distribution";
import { ManageApproval } from "../containers";
import MappingTemplate from "../layouts/Mapper/MappingTemplates/MappingTemplate";
import { appLayoutStore, ManagePayrollProvider } from "../contexts";
import { Toast } from "react-bootstrap";
import { globalToastInfo } from "./../contexts/reducers/app-layout/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { ManageCensusProvider } from "../contexts";

import FileStatusReport from "../layouts/FileStatusReport";
import FullTransactionReport from "../layouts/FullTransactionReport";
import UserRegistration from "../layouts/UserRegistration/UserRegistration";
const Routes = () => {
  const { state, dispatch } = useContext(appLayoutStore);
  const { showToast, toastMessage } = state;

  return (
    <div>
      <Switch>
        <ApplicationRoute
          exact
          menu="home"
          path={ROUTES.HOME}
          component={Home}
        />
        <ApplicationRoute
          exact
          menu="new-home"
          path={"/new-home"}
          component={NewHome}
        />
        <ApplicationRoute
          exact
          menu="company"
          path={ROUTES.COMPANY}
          component={Company}
        />
        <ApplicationRoute
          exact
          menu="plan"
          path={ROUTES.PLAN}
          component={Plan}
        />
        <ApplicationRoute
          menu="company"
          path={ROUTES.MANAGE_COMPANY}
          component={ManageCompany}
        />
        <ApplicationRoute
          menu="plan"
          path={ROUTES.SUCCESS_PLAN}
          component={SuccessPlan}
        />
        <ApplicationRoute
          menu="plan"
          path={ROUTES.MANAGE_PLAN}
          component={ManagePlan}
        />
        <ApplicationRoute
          menu="eligibility"
          path={ROUTES.MANAGE_ELIGIBILITY}
          component={ManageEligibility}
        />
        {/* file status report  */}
        <ApplicationRoute
          menu="fileStatusReport"
          path={ROUTES.FILESTATUSREPORT}
          component={FileStatusReport}
        />
        {/* full transaction report  */}
        <ApplicationRoute
          menu="full-transaction-report"
          path={ROUTES.FULLTRANSACTIONREPORT}
          component={FullTransactionReport}
        />
        <ApplicationRoute
          menu="userRegistration"
          path={ROUTES.USER_REGISTRATION}
          component={UserRegistration}
        />
        <Redirect menu="mapper" from={ROUTES.MAPPER} to={ROUTES.MAPPER_HOME} />
        <ApplicationRoute
          menu="mapper"
          path={ROUTES.MAPPER}
          component={Mapper}
        />
        <ApplicationRoute
          menu="mapper"
          path={ROUTES.MAPPER_HOME}
          component={MapperHome}
        />
        <ApplicationRoute
          menu="mapper"
          path={ROUTES.MANAGE_MAPPER}
          component={Mapper}
        />
        <ApplicationRoute
          menu="outputFiles"
          path={ROUTES.OUTPUT_FILES}
          component={OutputFiles}
        />
        <ApplicationRoute
          menu="doco"
          path={ROUTES.DOCO_CENTER}
          component={Doco_Center}
        />
        <ApplicationRoute menu="doco" path={ROUTES.DOCO} component={Doco} />

        <ApplicationRoute
          exact
          menu="payroll"
          path={[
            `${MANAGE_PAYROLL_ROUTES.CENSUS_AND_PAYROLL}/:payrollId?/:employeeId?`,
          ]}
          component={PayrollCensusDetailsContainer}
        />

        <ApplicationRoute
          menu="employees"
          path={ROUTES.MANAGE_EMPLOYEE}
          component={ManageEmployee}
        >
          <ManageCensusProvider>
            <ManageEmployee />
          </ManageCensusProvider>
        </ApplicationRoute>

        <ApplicationRoute
          menu="employees"
          path={ROUTES.MANAGE_CENSUS}
          component={ManageCensus}
        >
          <ManageCensusProvider>
            <ManageCensus />
          </ManageCensusProvider>
        </ApplicationRoute>
        <ApplicationRoute
          menu="distribution"
          path={ROUTES.DISTRIBUTION}
          component={Distribution}
        >
          <ManageCensusProvider>
            <Distribution />
          </ManageCensusProvider>
        </ApplicationRoute>
        <ApplicationRoute
          menu="maintenance"
          path={ROUTES.MANAGE_MAINTENANCE}
          component={ManageMaintenance}
        />
        <ApplicationRoute
          menu="communication"
          path={ROUTES.MANAGE_COMMUNICATION}
          component={ManageCommunication}
        />
        <ApplicationRoute
          menu="reports"
          path={ROUTES.MANAGE_REPORTS}
          component={ManageReport}
        />
        <ApplicationRoute
          menu="masters"
          path={ROUTES.MASTERS}
          component={ManageMaster}
        />
        <ApplicationRoute menu="fee" path={ROUTES.FEE} component={ManageFee} />

        <ApplicationRoute
          menu="fee"
          path={ROUTES.CREATE_FEE}
          component={CreateFee}
        />

        <ApplicationRoute
          menu="fee"
          path={ROUTES.FEE_RUN}
          // path={[
          //   `${ROUTES.FEERUN}/:feeRunId?`,
          // ]}
          component={FeeRun}
        />
        {/* <ApplicationRoute path={ROUTES.MANAGE_REPORTS} component={Reports} /> */}
        <ApplicationRoute
          menu="calculators"
          path={ROUTES.CALCULATORS}
          component={UnderConstruction}
        />

        <ApplicationRoute
          menu="enrollment"
          path={`${MANAGE_ENROLLMENT_ROUTES.ENROLLMENT_DETAIL_REPORT}/:flow(add|edit|save)/:planId/:companyId`}
          component={EnrollmentDetailReport}
        />
        <ApplicationRoute
          exact
          menu="enrollment"
          path={ROUTES.ENROLLMENT}
          component={EnrollmentReport}
        />
        <ApplicationRoute
          exact
          menu="sponsor"
          path={ROUTES.SPONSOR}
          component={SponsorLayout}
        />

        <ApplicationRoute
          exact
          menu="sponsor"
          path={`${ROUTES.SPONSOR}/employee/summary`}
          component={SponsorEmployeeSummaryContainer}
        />

        <ApplicationRoute
          menu="rkaas"
          path={ROUTES.RKAAS}
          component={ManageRkaas}
        />
        <ApplicationRoute
          menu="trade"
          path={ROUTES.TRADE}
          component={ManageTrade}
        />
        <ApplicationRoute
          menu="transaction"
          path={ROUTES.TRANSACTION}
          component={ManageTransaction}
        />

        <ApplicationRoute
          menu="templates"
          path={ROUTES.TEMPLATES}
          component={UnderConstruction}
        />
        <ApplicationRoute
          menu="mappingTemplates"
          path={ROUTES.MAPPING_TEMPLATES}
          component={MappingTemplate}
        />
        <ApplicationRoute
          path={ROUTES.FORFEITURE}
          component={ManageForfeitureSummary}
        />

        <ManagePayrollProvider>
          <Switch>
            <ApplicationRoute
              menu="payroll"
              path={ROUTES.MANAGE_TEMPMAP}
              component={ManageTempMap}
            />
            <ApplicationRoute
              exact
              menu="payroll"
              path={[
                ROUTES.PAYROLL_REPORTS,
                `${ROUTES.PAYROLL_REPORTS}/:payrollId?`,
              ]}
              component={PayrollReports}
            />
            <ApplicationRoute
              menu="payroll"
              path={ROUTES.MANAGE_PAYROLL}
              component={PayrollManage}
            />

            <ApplicationRoute
              exact
              menu="payroll"
              path={[
                `${MANAGE_PAYROLL_ROUTES.CREATE_PAYROLL_LISTING}/:payrollId?`,
                `${MANAGE_PAYROLL_ROUTES.CREATE_PAYROLL_LISTING}/:flow(edit)/:payrollId?`,
              ]}
              component={CreatePayrollListing}
            />

            <ApplicationRoute
              exact
              menu="payroll"
              path={[
                ROUTES.PAYROLL_FILE_STATUS,
                `${ROUTES.PAYROLL_FILE_STATUS}/:payrollId?`,
              ]}
              component={PayrollFileStatus}
            />

            <ApplicationRoute
              exact
              menu="payroll"
              path={ROUTES.PAYROLL}
              component={ManagePayroll}
            />
            <Redirect exact from="/" to={ROUTES.PAYROLL} />
            <Route
              path={ApplicationPaths.ApiAuthorizationPrefix}
              component={ApiAuthorizationRoutes}
            />
            <Route component={Error} />
          </Switch>
        </ManagePayrollProvider>

        <Redirect exact from="/" to={ROUTES.PAYROLL} />
        <Route
          path={ApplicationPaths.ApiAuthorizationPrefix}
          component={ApiAuthorizationRoutes}
        />
        <Route component={Error} />
      </Switch>

      <Toast
        onClose={() =>
          dispatch(
            globalToastInfo({
              showToast: false,
              toastMessage: "",
            })
          )
        }
        show={showToast}
        style={{
          position: "fixed",
          top: "10rem",
          right: "2rem",
          zIndex: "100",
        }}
        delay={3000}
        autohide
      >
        {/* <Toast.Body className="success-toast-align">
        <div>{toastMessage}</div>
      </Toast.Body> */}

        <Toast.Body className="success-toast-align">
          <div className="mr-2">
            {showToast ? (
              <FontAwesomeIcon icon={faCheckCircle} color="#3BB54A" size="lg" />
            ) : (
              ""
            )}
          </div>
          <div>{toastMessage}</div>
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default Routes;
